export const SINA_VISIBILITY_EVENT = 'sinamon:sina-visibility-change';

const SINA_HIDDEN_KEY = 'sinamon.sina.hidden';

export function readSinaHidden() {
  try {
    return window.localStorage.getItem(SINA_HIDDEN_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setSinaHidden(hidden) {
  try {
    window.localStorage.setItem(SINA_HIDDEN_KEY, String(hidden));
  } catch {
    // La preferencia es opcional: el cambio sigue activo durante esta sesión.
  }
  window.dispatchEvent(new CustomEvent(SINA_VISIBILITY_EVENT));
}
